import { render } from "./CodiciIva.vue?vue&type=template&id=4e64e1c8&scoped=true"
import script from "./CodiciIva.vue?vue&type=script&lang=js"
export * from "./CodiciIva.vue?vue&type=script&lang=js"

import "./CodiciIva.vue?vue&type=style&index=0&id=4e64e1c8&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e64e1c8"]])

export default __exports__